<template>
  <div class="Warp">
    <van-grid :column-num="5" :border="false">
      <van-grid-item text="会员卡编号" />
      <van-grid-item text="会员卡名称" />
      <van-grid-item text="会员名称" />
      <van-grid-item text="余额" />
      <van-grid-item text="积分" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="uploader"
      >
        <div
          v-for="item in memberList"
          :key="item.card_no"
        >
          <van-grid :column-num="5" :border="false">
            <van-grid-item :text="item.card_no"> </van-grid-item>
            <van-grid-item :text="item.card_name"> </van-grid-item>
            <van-grid-item :text="item.consumer_name"> </van-grid-item>
            <van-grid-item :text="'￥'+item.balance"> </van-grid-item>
            <van-grid-item :text="String(item.integral)"> </van-grid-item>
            <!-- <van-grid-item
              :text="item.card_type == 'FULL_REDUCE' ? '满减' : '折扣'"
            /> -->
            <!-- <van-grid-item class="compant_name" text="说的话就发了客户接受的了看见对方离开手机都发了看见了可上单就放开了" /> -->
            <!-- <van-grid-item :text="item.num + ''" />
            <van-grid-item>
              <div class="van_grid_item">{{ item.date }}</div>
              <div class="van_grid_item">{{ item.time }}</div>
            </van-grid-item> -->
          </van-grid>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      limit: 10,
      memberList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
    };
  },
  mounted() {
    this.getMemberList();
  },
  methods: {
    getMemberList() {
      var reqData = {
        pageNum: this.page,
        pageSize: this.limit,
      };
      this.$http
        .post("/wechat/api.consumer/listConsumer",  reqData )
        .then((res1) => {
          var res = res1.body;
		  if(res.total==0){
			  this.finished = true;
		  }else{
			  res.rows.map((v) => {
				// let data_time = v.limit_end_date.split(" ");
				// v.date = data_time[0];
				// v.time = data_time[1];
				this.memberList.push(v);
				// console.log(data_time);
				this.loading = false;
				this.refreshLoading = false;
				if (this.memberList.length >= res.total) {
				  this.finished = true;
				}
			  });
		  }
          
        });
    },
    onRefresh() {
      this.page = 1;
      this.memberList = [];
      this.finished = false;
      this.getMemberList();
    },
    uploader() {
      this.page++;
      this.getMemberList();
    },
    // toDetail(item) {
    //   this.$router.push({
    //     path: "/statement_detail",
    //     query: item,
    //   });
    // },
  },
};
</script>
<style lang="less" scoped>
.van_grid_item {
  color: #646566;
  font-size: 0.32rem;
  line-height: 1.5;
  word-break: break-all;
}
</style>